import { toUUID } from '../../util/transform';
import { CertificateOfTitle } from '../global/CertificateOfTitle.enum';
import { TypeOfCertificateOfTitle } from '../global/TypeOfCertificateOfTitle.enum';
import type { ITicketTitleDetail } from './TicketTitleDetail.interface';

export default class TicketTitleDetail implements ITicketTitleDetail {
  idSecurity: string;
  titleType: TypeOfCertificateOfTitle;
  title: CertificateOfTitle;
  volume: number;
  lot: string;
  folio: number;
  plan: string;

  static build = (data: ITicketTitleDetail) => new TicketTitleDetail(data);
  static blank = () => new TicketTitleDetail();

  /**
   * Constructor
   * @param {ITicketTitleDetail} data
   */
  constructor(data?: ITicketTitleDetail) {
    this.idSecurity = toUUID(data?.idSecurity);
    this.titleType = TypeOfCertificateOfTitle.of(
      data?.titleType?.name || data?.titleType?.toString()
    );
    this.title = CertificateOfTitle.of(data?.title?.name || data?.title?.toString());
    this.volume = parseFloat(data?.volume || 0);
    this.lot = data?.lot || '';
    this.folio = parseFloat(data?.folio || 0);
    this.plan = data?.plan || '';
  }
}
